import React from 'react';
import styled from 'astroturf/react';

import { TextButton } from 'js/design_system/TextButton';
import PremiumBadge from 'js/liswp/sidebar_ds/PremiumBadge';
import { Author } from 'js/liswp/Sidebar/hooks/types';
import { currentUser } from 'js/utils/user';

import UserCard from './UserCard';

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

type Props = {
  author: Author;
  onFollow?: <T extends Author>(author: T) => void;
  onMessage?: <T extends Author>(author: T) => void;
};

const AuthorCard: React.FC<Props> = ({ author, onFollow, onMessage }) => {
  return (
    <UserCard
      user={author}
      badge={author.show_premium_badge && <PremiumBadge />}
      footer={
        onFollow &&
        onMessage &&
        currentUser?.id !== author.id && (
          <Actions>
            <TextButton
              inline
              icon={author.following ? 'check' : 'add'}
              onClick={() => {
                onFollow(author);
              }}
            >
              {author.following ? 'Following' : 'Follow'}
            </TextButton>
            <TextButton
              inline
              icon="mail"
              onClick={() => {
                onMessage(author);
              }}
            >
              Message
            </TextButton>
          </Actions>
        )
      }
    />
  );
};

export default AuthorCard;
